/** @format — Primary pill used to start a shipment from Home or Shipments */

import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

type StartShipmentButtonProps = {
  onClick?: () => void;
  label?: string;
  className?: string;
  loading?: boolean;
};

export default function StartShipmentButton({
  onClick,
  label = "New shipment",
  className = "",
  loading = false,
}: StartShipmentButtonProps) {
  return (
    <Button
      type="button"
      onClick={loading ? undefined : onClick}
      disabled={loading}
      className={cn(
        "h-8 min-h-8 gap-1.5 rounded-full bg-[#2563EB] px-3 py-1.5 text-[14px] font-medium text-[#FAFAFA] shadow-none hover:bg-[#1C3BC7] active:scale-[0.98] active:bg-[#1C3BC7]",
        className,
      )}
    >
      {loading ? (
        <span className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-white border-t-transparent" />
      ) : (
        <span className="text-[14px] leading-none">+</span>
      )}
      {label}
    </Button>
  );
}
